
export const GET_NOTICE_LIST = "GET_NOTICE_LIST";
export const GET_NOTICE_LIST_RESPONCE = "GET_NOTICE_LIST_RESPONCE";
export const GET_NOTICE_TOTALS = "GET_NOTICE_TOTALS";
export const GET_NOTICE_TOTALS_RESPONCE = "GET_NOTICE_TOTALS_RESPONCE";
export const ADD_NOTICE = 'ADD_NOTICE';
export const EDIT_NOTICE = 'EDIT_NOTICE';
export const DELETE_NOTICE = 'DELETE_NOTICE';
export const CHANGE_STATUS_NOTICE = 'CHANGE_STATUS_NOTICE';
export const NOTICE_VIEW_REPORT = 'NOTICE_VIEW_REPORT';
export const NOTICE_VIEW_REPORT_RESPONCE = 'NOTICE_VIEW_REPORT_RESPONCE';

export const GET_NOTICE_REPORT_DATA = "GET_NOTICE_REPORT_DATA";



// redux state update 

export const CHNAGE_NOTICE_STATUS_REDUX_STATE = "CHNAGE_NOTICE_STATUS_REDUX_STATE";

export const GET_NOTICE_REPORT_DATA_REQUEST = "GET_NOTICE_REPORT_DATA_REQUEST";
export const GET_NOTICE_REPORT_DATA_SUCCESS = "GET_NOTICE_REPORT_DATA_SUCCESS";
export const GET_NOTICE_REPORT_DATA_FAILURE = "GET_NOTICE_REPORT_DATA_FAILURE";
